module.exports = __webpack_public_path__ + "img/118.4825cbe9.jpg";